import { render, staticRenderFns } from "./detail_mindset_page.vue?vue&type=template&id=efc01504&scoped=true"
import script from "./detail_mindset_page.vue?vue&type=script&lang=js"
export * from "./detail_mindset_page.vue?vue&type=script&lang=js"
import style0 from "./detail_mindset_page.vue?vue&type=style&index=0&id=efc01504&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efc01504",
  null
  
)

export default component.exports